export default "__VITE_ASSET__B_VJGEBW__"